import { type ComponentProps } from 'react'
import { Pillow } from '@/components/Pillow/Pillow'
import hedvigPillowImage from './hedvig-pillow.webp'

type Props = Omit<ComponentProps<typeof Pillow>, 'src'>

export const HedvigPillow = function HedvigPillow(props: Props) {
  return <Pillow {...props} src={hedvigPillowImage.src} />
}

HedvigPillow.displayName = 'HedvigPillow'
